var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1205 13.53C12.1005 13.53 12.0705 13.53 12.0505 13.53C12.0205 13.53 11.9805 13.53 11.9505 13.53C9.68047 13.46 7.98047 11.69 7.98047 9.51004C7.98047 7.29004 9.79047 5.48004 12.0105 5.48004C14.2305 5.48004 16.0405 7.29004 16.0405 9.51004C16.0305 11.7 14.3205 13.46 12.1505 13.53C12.1305 13.53 12.1305 13.53 12.1205 13.53ZM12.0005 6.97004C10.6005 6.97004 9.47047 8.11004 9.47047 9.50004C9.47047 10.87 10.5405 11.98 11.9005 12.03C11.9305 12.02 12.0305 12.02 12.1305 12.03C13.4705 11.96 14.5205 10.86 14.5305 9.50004C14.5305 8.11004 13.4005 6.97004 12.0005 6.97004Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 22.7501C9.30984 22.7501 6.73984 21.7501 4.74984 19.9301C4.56984 19.7701 4.48984 19.5301 4.50984 19.3001C4.63984 18.1101 5.37984 17.0001 6.60984 16.1801C9.58984 14.2001 14.4198 14.2001 17.3898 16.1801C18.6198 17.0101 19.3598 18.1101 19.4898 19.3001C19.5198 19.5401 19.4298 19.7701 19.2498 19.9301C17.2598 21.7501 14.6898 22.7501 11.9998 22.7501ZM6.07984 19.1001C7.73984 20.4901 9.82984 21.2501 11.9998 21.2501C14.1698 21.2501 16.2598 20.4901 17.9198 19.1001C17.7398 18.4901 17.2598 17.9001 16.5498 17.4201C14.0898 15.7801 9.91984 15.7801 7.43984 17.4201C6.72984 17.9001 6.25984 18.4901 6.07984 19.1001Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.7501C6.07 22.7501 1.25 17.9301 1.25 12.0001C1.25 6.07006 6.07 1.25006 12 1.25006C17.93 1.25006 22.75 6.07006 22.75 12.0001C22.75 17.9301 17.93 22.7501 12 22.7501ZM12 2.75006C6.9 2.75006 2.75 6.90006 2.75 12.0001C2.75 17.1001 6.9 21.2501 12 21.2501C17.1 21.2501 21.25 17.1001 21.25 12.0001C21.25 6.90006 17.1 2.75006 12 2.75006Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.a3e7d6195917b444bb8bce5dda7357a2.svg";
export { ForwardRef as ReactComponent };